// Constants
export const garantia_diagnosticos = () => {
    return {
        garantia_diagnosticos: {
            id: {
                label: 'Id',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                description: 'id autoincrement',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: ''
                }
            },
            id_info_garantia: {
                type: 'number',
                label: 'Tipo',
                placeholder: '',
                description: 'key forein info_examens',
                readonly: true,
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                datatype: {
                    predeterminate: '',
                }
            },
            lente: {
                type: 'text',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                label: 'Tipo De Lente',
                placeholder: '',
                description: 'Diagnostico',
                validate: 'required',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            uso: {
                type: 'text',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                label: 'Uso',
                placeholder: '',
                description: 'Uso',
                validate: 'required',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            alt_bf: {
                type: 'text',
                label: 'ALT BF',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'alt bf',
                validate: 'required',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            aumento: {
                type: 'text',
                label: 'Aumento Lente',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'aumento lente',
                validate: 'required',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ciclopejia: {
                type: 'text',
                label: 'Ciclopejia',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Ciclopejia',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            observacion: {
                type: 'text',
                label: 'Diagnostico',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Diagnostico',
                validate: '',
                datatype: {
                    type: 'textarea',
                    disabled: false,
                    predeterminate: '',
                }
            },
            conducta: {
                type: 'text',
                label: 'Conducta',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Conducta',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_esf: {
                type: 'text',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                label: '',
                placeholder: '',
                description: 'Od esf',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_cil: {
                type: 'text',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                label: '',
                placeholder: '',
                description: 'Od cil',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_eje: {
                type: 'text',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                label: '',
                placeholder: '',
                description: 'Od eje',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_add: {
                type: 'text',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                label: '',
                placeholder: '',
                description: 'Od add',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_av: {
                type: 'text',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                label: '',
                placeholder: '',
                description: 'Od av',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_dp: {
                type: 'text',
                label: '',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Od dp',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_esf: {
                type: 'text',
                label: '',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Oi esf',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_cil: {
                type: 'text',
                label: '',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Oi cil',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_eje: {
                type: 'text',
                label: '',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Oi eje',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_add: {
                type: 'text',
                label: '',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Oi add',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_av: {
                type: 'text',
                label: '',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Oi av',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_dp: {
                type: 'text',
                label: '',
                dataform: ['paciente_garantias', 'orden_garantias', 'orden_pendgarantias'],
                placeholder: '',
                description: 'Oi dp',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
        }
    }
}

export function asign_garantia_diagnosticos() {
    var asign = Object.keys(garantia_diagnosticos().garantia_diagnosticos);
    var objeto = garantia_diagnosticos().garantia_diagnosticos
    var nuevoArray = {}
    for (var i = 0; i < asign.length; i++) {
        var createdataform = objeto[asign[i]].dataform
        for (var j = 0; j < createdataform.length; j++) {
            nuevoArray[createdataform[j]] = {}
        }
    }
    return nuevoArray
}